import React from 'react'
import styled from 'styled-components'
import { Color, ButtonSize } from '../types/styled'
import { StyledFunctions } from '../utils'

const IconRoot = styled.div<{ color: Color, size: ButtonSize }>`
  display: inline-flex;
  align-items: center;
  flex-grow: unset;
  
  svg {
    path {
      fill: ${props => props.theme.color.icon[props.color]};
    }
  }
`

interface Props {
  icon: React.ReactElement
  size?: ButtonSize
  color?: Color
  style?: React.CSSProperties
}

const Icon = ({ icon, color = 'primary', size = 'm', style }: Props) => {
  return (
    <IconRoot color={color} size={size}>
      {React.cloneElement(icon, {
        style,
        width: StyledFunctions.getIconSize(size),
        height: StyledFunctions.getIconSize(size),
      })}
    </IconRoot>
  )
}

export { Icon }